import { render, staticRenderFns } from "./LegendMap.vue?vue&type=template&id=0f1fa860&scoped=true&"
import script from "./LegendMap.vue?vue&type=script&lang=js&"
export * from "./LegendMap.vue?vue&type=script&lang=js&"
import style0 from "./LegendMap.vue?vue&type=style&index=0&id=0f1fa860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1fa860",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemAction } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VDivider,VList,VListItem,VListItemAction,VListItemTitle,VMenu,VSpacer})
